import { Module } from "vuex";

import { FriendsState } from "./types";

import { actionNames, actions } from "./actions";
import { mutationNames, mutations } from "./mutations";
import { getterNames, getters } from "./getters";

import { RootState } from "../../types";

export const api = {
  namespace: "friends",
  getters: getterNames,
  mutations: mutationNames,
  actions: actionNames,
  state: {
    friends: "friends",
  },
};

const module: Module<FriendsState, RootState> = {
  namespaced: true,
  state: () => new FriendsState(),
  actions,
  mutations,
  getters,
};

export default module;
